import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    FormBuilder,
    FormGroup,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AppIconComponent } from '../../../../../common/components/icon/icon.component';
import { FormInputDirective } from '../../../../../common/directives/form-input.directive';
import { NgxMaskDirective } from 'ngx-mask';

export interface AffectedInsurance {
    name: string;
    questions: {
        text: string;
        answer: boolean;
    }[];
}

export interface SpecialRequestData {
    nombre: string;
    cedula: string;
    email: string;
    telefono: string;
}

@Component({
    selector: 'app-special-request-modal',
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        AppIconComponent,
        FormInputDirective,
        NgxMaskDirective,
    ],
    templateUrl: './special-request-modal.component.html',
    styleUrl: './special-request-modal.component.css',
})
export class SpecialRequestModalComponent {
    /** List of insurance type details that triggered the special condition */
    @Input() affectedInsurances: AffectedInsurance[] = [];

    form: FormGroup;

    constructor(
        private readonly fb: FormBuilder,
        public readonly activeModal: NgbActiveModal,
    ) {
        this.form = this.fb.group({
            nombre: ['', [Validators.required]],
            cedula: ['', [Validators.required]],
            email: ['', [Validators.required, Validators.email]],
            telefono: ['', [Validators.required]],
        });
    }

    submit(): void {
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            return;
        }

        const data: SpecialRequestData = {
            nombre: this.form.get('nombre')?.value ?? '',
            cedula: this.form.get('cedula')?.value ?? '',
            email: this.form.get('email')?.value ?? '',
            telefono: this.form.get('telefono')?.value ?? '',
        };

        this.activeModal.close(data);
    }

    cancel(): void {
        this.activeModal.dismiss('cancel');
    }
}
